__turbopack_context__.v({
  "breadcrumbs-listing-container": "ListingBreadcrumbs-module-scss-module__zO93vG__breadcrumbs-listing-container",
});
